// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___9e68b070ad44aabeefa","cls2":"BulkFollowListModal-cls2__f2cb8e4e9a9be8871afa BulkFollowListModal-cls1___9e68b070ad44aabeefa"};